module.exports = __webpack_public_path__ + "static/media/plus-preto.bb16e071.jpg";